import React, { lazy, Suspense, useEffect } from 'react';
import aws_exports from './aws-exports';
import { Amplify } from 'aws-amplify';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import './App.css';
import LoadPage from './components/Loading';
import Check from './components/Check';
import Control from './components/Control';
import View from './components/View';

const Home = lazy(()=>import('./components/Home'));
const Results = lazy(()=>import('./components/Results'));
const Detail = lazy(()=>import('./components/Detail'));
const Tutorial = lazy(()=>import('./components/Tutorial'));
const Viz = lazy(()=>import('./components/Viz'));

Amplify.configure(aws_exports);

export default function App() {

  function clearAllCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;)
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
  }

  useEffect(() => {
    clearAllCookie();
  }, []);

  return (
    <Router>
      <Suspense fallback={<LoadPage />}>
      <Switch>

        <Route path="/tutorial">
          <Tutorial />
        </Route>

        <Route path="/view">
          <View />
        </Route>

        <Route path="/results">
          <Results />
        </Route>

        <Route path="/detail/:id">
          <Detail />
        </Route>

        <Route path="/check/:id">
          <Check />
        </Route>

        <Route path="/control/:id">
          <Control />
        </Route>

        <Route path="/detail">
          <Redirect to="/results" />
        </Route>

        <Route path="/viz/:url">
          <Viz />
        </Route>

        <Route path="/viz">
          <Redirect to="/results" />
        </Route>

        <Route path="/">
          <Home />
        </Route>

      </Switch>
      </Suspense>
    </Router>
  )
};
